<template>
    <form id="onboarding-de" class="wrapper tab-diagnose" role="form" method="post">
        <header class="header-with-confetti">
            <span class="new-headline-xlg text-centered">Vitadio ist für Sie geeignet!</span>
            <p class="new-text-lg text-centered text-color-default">Vielleicht haben Sie doch einen Diagnosenachweis, ohne es zu wissen. Ein Diagnosenachweis kann alles sein, woraus hervorgeht, dass Sie die Diagnose Typ-2-Diabetes haben, z.B.</p>
        </header>

        <div class="text-wrapper">
            <ul class="list-w-check">
                <li>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                            <span>check</span>
                        </span>
                    </figure>
                    <span class="new-text-xl">Arztbrief</span>
                </li>
                <li>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                            <span>check</span>
                        </span>
                    </figure>
                    <span class="new-text-xl">Diabetespass</span>
                </li>
                <li>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                            <span>check</span>
                        </span>
                    </figure>
                    <span class="new-text-xl">Überweisungsschein</span>
                </li>
                <li>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                            <span>check</span>
                        </span>
                    </figure>
                    <span class="new-text-xl">Medikamentenplan</span>
                </li>
                <li>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                            <span>check</span>
                        </span>
                    </figure>
                    <span class="new-text-xl">Befundbericht</span>
                </li>
                <li>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green">
                            <span>check</span>
                        </span>
                    </figure>
                    <span class="new-text-xl">Bescheinigung der Arbeitsunfähigkeit (AU)</span>
                </li>
            </ul>

            <strong class="new-headline-md text-centered">Haben Sie doch einen Diagnosenachweis?</strong>
        </div>

        <div class="form-input-radio-button-wrapper-two-columns">
            <div 
                class="form-input-radio-button-big"
                id="yes"
                @click="chooseOption('Yes')"
                >
                <div class="form-input-radio-button-inner">
                    <figure class="form-input-radio-button-icon">
                        <span class="material-symbols-rounded">done</span>
                    </figure> 
                    <span class="label-static">Ja</span>
                </div>
            </div>
            
            <div 
                class="form-input-radio-button-big form-input-radio-button--danger"
                id="no"
                @click="chooseOption('No')"
                >
                <div class="form-input-radio-button-inner">
                    <figure class="form-input-radio-button-icon">
                        <span class="material-symbols-rounded">close</span>
                    </figure> 
                    <span class="label-static">Nein</span>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        methods: {
            chooseOption(selection) {
                if (selection === 'Yes') {
                    setTimeout(() => {
                        this.$emit('clicked', 'app')
                    }, 250);
                }

                if (selection === 'No') {
                    setTimeout(() => {
                        this.$emit('clicked', 'info')
                    }, 250);
                }
            },
        }
    }
</script>